import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 65"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#36A635",
  d: "M62.792 9.48H3.209v14.895h59.583z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#BFBFBF",
  d: "M49.25 2.708h-4.062V16.25h4.062zM62.792 24.375H3.209v37.917h59.583zM20.813 2.708H16.75V16.25h4.063z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20.813 29.792H7.27v10.833h13.542zM39.77 29.792H26.23v10.833h13.542zM58.73 29.792H45.187v10.833h13.541zM20.813 46.042H7.27v10.833h13.542zM39.77 46.042H26.23v10.833h13.542z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0A0B0D",
  d: "M58.73 46.042H45.187v10.833h13.541zM49.25 9.48h-4.062v6.77h4.062zM20.813 9.48H16.75v6.77h4.063z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }